GetLocalization = function () {
    if (localStorage.getItem('locale') !== 'en'
        && localStorage.getItem('locale') !== 'ar') {
        localStorage.setItem('locale', 'en');
    }
    return localStorage.getItem('locale');
};

const applicationName = 'QDB Vendor Reg.';
GetToken = function() {
    var token = localStorage.getItem(applicationName + 'token');
    return token;
}

SetToken = function(token) {
    localStorage.setItem(applicationName + 'token', token);
    return token;
}

RemoveToken = function() {
    localStorage.removeItem(applicationName + 'token');
}

ErrorAlertMessage = function(message) {
    //toastr.error(message);
    toastr.error(message);
};

SuccessAlertMessage = function(message) {
    toastr.success(message);
};

WarningAlertMessage = function(message) {
    toastr.warning(message);
};

const isRtl = document.documentElement.getAttribute('dir') === 'rtl'; // or detect from your i18n setup
let loaderMessage = isRtl ? 'جاري التحميل...' : 'Loading...';

let loaderContent = `
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="custom-logo-loader mb-3"></div>
        <div class="loading-text">${loaderMessage}</div>
    </div>
`;
    
BlockPage = function(element = null) {
    if (element == null) {
        $.blockUI({
            message: loaderContent,
            css: {
                backgroundColor: 'transparent',
                border: '0',
                zIndex: 9999999
            },
            overlayCSS: {
                backgroundColor: 'white',
                opacity: 1,
                zIndex: 9999990
            }
        });
    } else {
        element.blockUI({
            message: loaderContent,
            css: {
                backgroundColor: 'transparent',
                border: '0',
                zIndex: 9999999
            },
            overlayCSS: {
                backgroundColor: 'white',
                opacity: 1,
                zIndex: 9999990
            }
        });
    }
};

UnBlockPage = function(element = null) {
    if (element == null) {
        $.unblockUI();
    } else {
        element.unblockUI();
    }
};

DownloadBase64File = function (contentType, base64Data, fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    //console.log(linkSource);
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}
